/**
 * @file
 */

(function ($, Drupal, once) {
  'use strict';

  function setCookie(cookieName, cookieValue, exdays) {
    let date = new Date();
    date.setTime(date.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = 'expires=' + date.toUTCString();

    document.cookie = cookieName + '=' + cookieValue + ';' + expires + ';path=/';
  }

  function getCookie(cname) {
    let name = cname + '=';
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  // We will have some code outside Drupal Behaviour.
  // This code should be executed only once, and as soon as possible.
  // If I am in a TLD page and cookie is set, redirect user.
  let TLDPage = $('.page-node-type-jnjethicon-tld-landing-page').length;
  let TLDRedirectLink = getCookie('ethicon_country');


  if (TLDPage) {
    if (TLDRedirectLink) {
      // I want to take out of browser history the fact we hit the TLD.
      // That is why I am using .replace here.
      window.location.replace(`/${TLDRedirectLink}`);
    }

    $.ajax({
      type: "GET",
      url: Drupal.url('jnjethicon_localization/get_country'),
      success: (data) => {
      // This section will update the modal with data
      // based on the user's IP address. It is loaded by AJAX on page load.
      $('#jnjethicon-localizationcountry-select #edit-link').html(data.label);
      $('#jnjethicon-localizationcountry-confirm input[name="path"]').val(data.redirect);
      $('#jnjethicon-localizationcountry-confirm input[name="redirect"]').val(data.redirect);
      $('#jnjethicon-localizationcountry-confirm input[name="region"]').val(data.region);
      $('#jnjethicon-localizationcountry-confirm input[name="country"]').val(data.country);
  },
  });
  }


  Drupal.behaviors.jnjethicon_localization_select = {
    // Moves localization country select to hero container.
    attach: function (context) {
      let heroRegion = '.field--name-field-tld-hero-image';
      let countrySelectRegion = '.jnjethicon-localizationcountry-select';
      let btnChoseRegion = '.btn-chose';
      let $countryBlock = $(countrySelectRegion, context).detach();

      // Moves country block.
      $(once('jnjethicon_country_block', heroRegion, context)).append($countryBlock);

      $(once('jnjethicon-animation', btnChoseRegion, context)).each(function () {
        $(this).on('click', function() {
          let $aTag = $('#country-select');
          $('html, body').animate({ scrollTop: $aTag.offset().top });
        });
      });

      $($countryBlock, context).show();
    }
  };

  Drupal.behaviors.jnjethicon_localization_modal = {
    // Moves localization country select to hero container.
    attach: function (context) {
      const linkRegion = '.country-link';
      const modalRegion = '#block-ethiconlocalizationmodalblock';
      const languageFieldRegion = 'language-country-field';
      const laguagesWrapperRegion = 'country-languagues-wrapper';
      const pathField = '#jnjethicon-localizationcountry-confirm input[name="path"]';

      // When the users clicks on some countries in bottom of TLD page.
      $(once('jnjethicon_country_link',linkRegion, context)).each(function () {
        $(this).on('click', (event) => {
          event.preventDefault();

          let $this = $(this);
          // Get default values and set them.
          let languagesData = $this.data('language').split(',');
          let redirectData = $this.data('redirect').split(',');
          let buttonsRegion = '#jnjethicon-localizationcountry-confirm .buttons-wrapper';
          let region = $this.data('region');
          // Country is fixed, based on IP address.
          let country = $('#jnjethicon-localizationcountry-confirm input[name="country"]').val();
          let show = $this.data('show');
          let original = $('#jnjethicon-localizationcountry-confirm .localization-content-original').html();
          let replaced = original.replace(/@region/g, region);

          // Set localization content.
          replaced = replaced.replace(/@country/g, country);
          $('#jnjethicon-localizationcountry-confirm .localization-content').html(replaced);

          // Clean content.
          $(`#js-${laguagesWrapperRegion}`).remove();

          // If the user clicked on a regional link, do not display country radios.
          if (show) {
            // Create language fields.
            let fields = `
                <ul id="js-${laguagesWrapperRegion}" class="${laguagesWrapperRegion}">
                  ${languagesData.map((val, index) => `
                    <li class="item">
                      <input type="radio"
                        id="language-${index}"
                        class="${languageFieldRegion}"
                        name="language"
                        value="${redirectData[index]}">
                      <label for="language-${index}">${val}</label>
                    </li>
                  `).join('')}
                </ul>
                  `;
            // Insert the new fields on the page.
            $(buttonsRegion).before(fields);

            // Add events to get the value when the user chooses the language and check the first field.
            $(`.${languageFieldRegion}`).click(function () {
              $(pathField).val($(this).val());
            })
              .first()
              .click();
          }
          else {
            $(pathField).val(redirectData[0]);
          }

          // Show modal.
          $(modalRegion).modal('show');

          return false;
        });
      });

      // When the user clicks on red "take me to" button on TLD page.
      $('#edit-link', context).click(function (event) {
        // Stop the click.
        event.preventDefault();

        // Get default values and set them.
        let redirect = $('#jnjethicon-localizationcountry-confirm input[name="redirect"]').val();
        let region = $('#jnjethicon-localizationcountry-confirm input[name="region"]').val();
        let country = $('#jnjethicon-localizationcountry-confirm input[name="country"]').val();
        let original = $('#jnjethicon-localizationcountry-confirm .localization-content-original').html();
        let replaced = original.replace(/@region/g, region);
        replaced = replaced.replace(/@country/g, country);
        const pathField = '#jnjethicon-localizationcountry-confirm input[name="path"]';

        $('#jnjethicon-localizationcountry-confirm .localization-content').html(replaced);
        $(pathField).val(redirect);

        // Clean content.
        $(`#js-${laguagesWrapperRegion}`).remove();

        // Opens the modal. Modal is using Bootstrap.
        $('#block-ethiconlocalizationmodalblock').modal('show');
      });

      // When the user clicks on red continue button in modal.
      $('.localization-continue', context).click(function (event) {
        event.preventDefault();

        let link = $(pathField).val();

        setCookie('ethicon_country', link, drupalSettings.jnjethicon_localization.cookie_lifespan);
        window.location.href = `/${link}`;
      });
    }
  };

})(jQuery, Drupal, once);
